import type { FaireProductEntity } from "../../entity_types/product";

export const p_aph97ufnp7: FaireProductEntity = {
  token: "p_aph97ufnp7",
  type: "product",
  name: "Custom Beach Tote Bag with Rope Handles \u00ad Personalized",
  brandName: "Sockprints",
  imageUrl:
    "https://cdn.faire.com/fastly/363ab17c2a05674d52afa71ebae6c754150789913fdba3546114b9cdbc79be8e.jpeg",
  priceDollars: 12.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/0be64d0cd3dfe91a13dfa54cce611f90033ead3b2a99b6f23861d7686d4f431b.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
